const termsContent = [
    {
        id: 1,
        title: 'Acceptance of Terms',
        content: `By using our website and services, you agree to comply with these Terms of Service and any additional terms and conditions provided within our website. If you do not agree with any part of these terms, please refrain from using our services.`
    },
    {
        id: 2,
        title: 'Use of the Website',
        content: `You must be at least 18 years old to use our services.
        You are responsible for maintaining the confidentiality of your account information and are liable for all activities that occur under your account.
        You agree not to use our website for any unlawful or unauthorized purpose, including but not limited to distributing harmful content, violating intellectual property rights, or engaging in fraudulent activities.`
    },
    {
        id: 3,
        title: 'Ordering and Payments',
        content: `When placing an order, you agree to provide accurate and complete information, including payment details.
        You authorize us to charge your provided payment method for the total amount of your order, including applicable taxes, fees, and delivery charges.
        Orders are subject to availability and confirmation. We reserve the right to reject or cancel orders at our discretion.`
    },
    {
        id: 4,
        title: 'Content',
        content: `You are responsible for the content you submit on our website, including reviews and comments. Your content should not violate any laws or infringe upon any third-party rights.
        We may use and display user-generated content for promotional purposes on our website and other marketing materials.`
    },
    {
        id: 5,
        title: 'Intellectual Property',
        content: `All content on our website, including text, images, logos, and trademarks, is the property of Delish Hut and its licensors. You may not use, reproduce, or distribute our content without explicit permission.`
    },
    {
        id: 6,
        title: 'Limitation of Liability',
        content: `We are not liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of our website or services.
        We do not endorse, warrant, or assume responsibility for the accuracy or reliability of any content or information on our website.`
    },
    {
        id: 7,
        title: 'Termination',
        content: `We reserve the right to suspend, terminate, or restrict your access to our services at our discretion, without prior notice.
        You can terminate your account at any time by contacting our customer support.`
    },
    {
        id: 8,
        title: 'Privacy',
        content: `Your use of our website and services is also governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information.`
    },
    {
        id: 9,
        title: 'Changes to Terms',
        content: `We reserve the right to modify these Terms of Service at any time. We will notify you of significant changes through our website or by email.`
    },

]

export default termsContent;